module.exports = __webpack_public_path__ + "img/[哇].9cb559b4.svg";